var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { isNil, isEmpty, anyPass, complement } from 'ramda';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
var isNotEmpty = complement(anyPass([isNil, isEmpty]));
var LabelControl = /** @class */ (function (_super) {
    __extends(LabelControl, _super);
    function LabelControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelControl.prototype.elementRender = function (def) {
        var frontOptions = def.frontOptions, value = def.value, label = def.label;
        var hint = frontOptions.hint, optLabel = frontOptions.label, restOptions = __rest(frontOptions, ["hint", "label"]);
        var val = isNotEmpty(optLabel) ? optLabel :
            isNotEmpty(value) ? value :
                isNotEmpty(label) ? label :
                    null;
        var displayValue = !!val && typeof (val) !== 'string' && typeof (val) !== 'number' ? 'Ошибка!' : val;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", __assign({ htmlFor: def.id, title: hint }, omitSpecialProperties(restOptions), { "field-code": def.code }), displayValue),
            React.createElement(ControlError, { error: this.error, touched: true }));
    };
    return LabelControl;
}(FormBaseElement));
export { LabelControl };
//# sourceMappingURL=Label.js.map